/**
 * Filtro PostgREST per cercare i prodotti per nome O SKU (match parziale).
 *
 * Il testo digitato va tra doppi apici: senza, una virgola o una parentesi
 * (es. "THC 0,5") spezzano la sintassi di `.or(...)` e la ricerca risponde
 * con errore PGRST100 invece che con risultati. Dentro gli apici `"` e `\`
 * vanno preceduti da backslash (docs.postgrest.org → URL grammar, reserved
 * characters).
 *
 * Uso: `query.or(productSearchFilter(testo))`
 */
export function productSearchFilter(term: string, fields: string[] = ['name', 'sku']): string {
  const safe = term.trim().replace(/\\/g, '\\\\').replace(/"/g, '\\"');
  return fields.map(field => `${field}.ilike."%${safe}%"`).join(',');
}
